<div class="header">
  <div class="header-left">
    <div class="title">{{ "chatList.conversation" | translate }}</div>
    <div class="subtitle">{{ chatService.conversations().length }} {{ "chatList.activeChats" | translate }}</div>
  </div>
  <button class="back-button" (click)="navigateToList()">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      class="lucide lucide-arrow-left h-4 w-4">
      <path d="m12 19-7-7 7-7"></path>
      <path d="M19 12H5"></path>
    </svg>
  </button>
</div>

<div class="list">
  @if (loading) {
    <ng-container *ngTemplateOutlet="loadingTpl"></ng-container>
  } @else {
    @for (conversation of chatService.conversations(); track conversation.id) {
      <ng-container *ngTemplateOutlet="conversationTpl; context: { $implicit: conversation }"></ng-container>
    }
  }
</div>

<!-- Loading Template -->
<ng-template #loadingTpl>
  <div class="mt-10px">
    <p-skeleton width="100%" height="76px" class="mt-10px"></p-skeleton>
  </div>
  <div class="mt-10px">
    <p-skeleton width="100%" height="76px" class="mt-10px"></p-skeleton>
  </div>
  <div class="mt-10px">
    <p-skeleton width="100%" height="76px" class="mt-10px"></p-skeleton>
  </div>
</ng-template>

<!-- Conversation Item Template -->
<ng-template #conversationTpl let-conversation>
  <div
    class="item"
    [ngClass]="{
      active: conversation.counterpartSwapRequest.id === activeConversationId(),
      unseen: conversation.newMessagesCount > 0,
    }"
    (click)="openConversation(conversation)">
    <div class="avatar">
      {{ conversation.counterpartSwapRequest.user?.name?.charAt(0) }}
    </div>

    <div class="meta">
      <div class="name-wrapper">
        <div class="name">{{ conversation.counterpartSwapRequest.user?.name }} {{ conversation.counterpartSwapRequest.user?.surname }}</div>
        <div class="property">
          {{ conversation.counterpartSwapRequest.property.numberOfRooms }} {{ "chatList.rooms" | translate }} -
          {{ conversation.counterpartSwapRequest.property.propertyType }}
        </div>
      </div>
      <div class="last">{{ conversation.lastMessage?.content }}</div>
    </div>
  </div>
</ng-template>
